/**
 * What: Merchant wording for TestFeed account sign-in and connection recovery in Shopify.
 * Transport / data-flow: Pure copy consumed by the embedded entry and readiness cards; no state or network effects.
 * Invariants: Signing in does not promise store access, cohort places or special pricing.
 */
/** Page controls and failure wording kept separate from admission policy. */
export const launchAdmissionCopy = {
    title: 'Connect TestFeed',
    checkFailedTitle: 'TestFeed connection could not be checked',
    checkFailedDescription: 'Reload the page and try again.',
    gateDescription: 'Sign in to your TestFeed account to connect this store. Your Shopify plan is managed separately.',
    planUnavailable: 'We could not load your Shopify plan link. You can still connect your TestFeed account.',
    chooseAccount: 'Choose your TestFeed account',
    accountNeeded: 'Account needed',
    section: 'Setup guide',
    progress: '0 of 3 steps done',
    planLocked: 'Connect your store before choosing a plan.',
    syncLocked: 'Connect your store and choose a plan before syncing Shopper Intelligence.',
    description: 'Sign in or create a TestFeed account to connect this store.',
    failed: 'We could not open TestFeed. Reload the app and try again.',
    reload: 'Reload app',
    refresh: 'Check again',
    signIn: 'Continue onboarding',
};
//# sourceMappingURL=launch-admission.js.map